import { buildMixpanelBoardUrl } from "@/v2-backoffice-client/analytics/analytics.utils"

export function buildMixpanelUserActivityUrl(email: string) {
  return buildMixpanelBoardUrl({
    resourceType: "user",
    propertyName: "$email",
    propertyType: "string",
    filterOperator: "equals",
    filterValue: email,
  })
}
